<h6 class="ion-margin-start">
  <ion-row class="ion-align-items-center ion-justify-content-between">
    <span>
      {{ exercise.name }}
    </span>
    <ion-button fill="clear" class="ion-no-margin" (click)="close()">
      <ion-icon name="close"></ion-icon>
    </ion-button>
  </ion-row>
</h6>

<me-exercise-video *ngIf="exercise.videos[0] as video" [video]="video"></me-exercise-video>

<ion-item lines="full" *ngIf="!(exercise.region | isEmpty)">
  <ion-note slot="start">
    {{ 'region' | translate }}
  </ion-note>
  <div slot="end" class="value-container">
    <ion-chip *ngFor="let region of exercise.region">
      <ion-icon name="locate-outline" color="dark"></ion-icon>
      <ion-label>{{region}}</ion-label>
    </ion-chip>
  </div>
</ion-item>
<ion-item lines="full" *ngIf="!(exercise.equipment | isEmpty)">
  <ion-note slot="start">
    {{ 'equipment' | translate }}
  </ion-note>
  <div slot="end" class="value-container">
    <ion-chip *ngFor="let equipment of exercise.equipment">
      <ion-icon name="barbell-outline" color="dark"></ion-icon>
      <ion-label>{{equipment}}</ion-label>
    </ion-chip>
  </div>
</ion-item>
<ion-item lines="full" *ngIf="!(exercise.bodyPosition | isEmpty)">
  <ion-note slot="start">
    {{ 'body.position' | translate }}
  </ion-note>
  <div slot="end" class="value-container">
    <ion-chip *ngFor="let bodyPosition of exercise.bodyPosition">
      <ion-icon name="body-outline" color="dark"></ion-icon>
      <ion-label>{{bodyPosition}}</ion-label>
    </ion-chip>
  </div>
</ion-item>
<ion-item lines="full" *ngIf="!(exercise.exerciseStyle| isEmpty)">
  <ion-note slot="start">
    {{ 'exerciseStyle' | translate }}
  </ion-note>
  <div slot="end" class="value-container">
    <ion-chip *ngFor="let exerciseStyle of exercise.exerciseStyle">
      <ion-label>{{exerciseStyle}}</ion-label>
    </ion-chip>
  </div>
</ion-item>
<ion-item lines="full" *ngIf="exercise.level">
  <ion-note slot="start">
    {{ 'level' | translate }}
  </ion-note>
  <div slot="end" class="value-container">
    <ion-chip>
      <ion-label>{{exercise.level}}</ion-label>
    </ion-chip>
  </div>
</ion-item>

<ion-item lines="full" *ngIf="exercise.internalNotes">
  <ion-note slot="start">
    {{ 'internalNotes' | translate }}
  </ion-note>
  <div slot="end" class="value-container white-space-normal">
    <ion-label>{{exercise.internalNotes}}</ion-label>
  </div>
</ion-item>
